import { bus, helper } from '@/utils'
import { getOperators, getPostData } from './helper'

export default {
  beforeDestroy () {
    bus.$off('show-add-notification')
  },
  computed: {
    hasConditionsError () {
      return this.errors.has('key') || this.errors.has('operator') || this.errors.has('target')
    },
    isStatusRule () {
      return this.data.ruleType === 'states'
    },
    ruleTypes () {
      return [
        {
          key: 'states',
          label: this.$t('notificationsCreateRuleTypesOptionStates'),
          value: 'states'
        }
      ]
    }
  },
  methods: {
    closePopup () {
      this.reset()
      this.showModal = false
    },
    reset () {
      this.data = {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        message: null,
        ruleType: 'states',
        title: null
      }
      this.loading = false
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    createNotification () {
      return this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.loading = true

            try {
              const rawData = Object.assign(this.data, { familyMembers: this.familyMembers })
              const data = getPostData(rawData, this.uid)
              const save = await this.$api.addNotification(data)
              if (save.status !== 201) {
                return
              }

              this.$message({
                message: this.$t('messageNotificationCreate'),
                showClose: true,
                type: 'success'
              })
            } catch (error) {
              const hasOwnerId = error.bodyText.match(/\\"ownerId\\"/g)
              const failedMsg = this.$t('NotificationsCreateFailedMessage')
              const noOwnerIdMsg = this.$t('NotificationsCreateFailedNoOwnerIdMessage')
              const message = hasOwnerId ? noOwnerIdMsg : failedMsg

              helper.showErrorMessage(this, this.component, error, message)
              this.loading = false
              return
            }

            bus.$emit('get-notifications-list')
            this.closePopup()
          }
        })
    }
  },
  name: 'NotificationsCreate',
  props: {
    familyMembers: {
      required: true,
      type: Object
    },
    familyNames: {
      required: true,
      type: Array
    },
    noQuota: {
      required: true,
      type: Boolean
    },
    uid: {
      default: null,
      type: Number
    }
  },
  data () {
    return {
      component: 'notificationsCreate',
      data: {
        conditions: {
          key: null,
          op: null,
          target: null
        },
        familyNames: [],
        message: null,
        ruleType: 'states', // Set default value as "device states" now
        title: null
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      operators: [],
      rules: {},
      labelWidth: '150px',
      loading: false,
      showModal: false,
      validate: {
        deviceKey: /^H([0-9A-F]){2}$/
      }
    }
  },
  mounted () {
    this.operators = getOperators()

    bus.$on('show-add-notification', (show) => {
      if (show) {
        this.showModal = true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationsCreate/NotificationsCreate.js